export enum SlideAction {
  GET_SLIDES = "getSlides",
  SET_SLIDES = "setSlides",
}
